// eslint-disable-next-line import/prefer-default-export
export const UPDATE_EMPLOYEE_BIDDABLE_PROFILE = 'UPDATE_EMPLOYEE_BIDDABLE_PROFILE';
export const UPDATE_EMPLOYEE_BIDDED_PROFILE = 'UPDATE_EMPLOYEE_BIDDED_PROFILE';
